export function SupportIcon() {
return (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="none"
  viewBox="0 0 16 16"
>
  <path
    className='neededFill'
    fill="#9197B3"
    d="M5.333 14.88c-.186 0-.38-.047-.553-.14-.38-.2-.613-.6-.613-1.027v-.946C2.153 12.56.833 11.08.833 8.96v-4c0-2.293 1.54-3.833 3.834-3.833h6.666c2.294 0 3.834 1.54 3.834 3.833v4c0 2.293-1.54 3.833-3.834 3.833H8.82l-2.84 1.894c-.193.126-.42.193-.647.193zM4.667 2.12c-1.72 0-2.834 1.113-2.834 2.833v4c0 1.72 1.114 2.834 2.834 2.834.273 0 .5.226.5.5v1.42c0 .086.053.126.086.146.034.02.1.04.174-.006l2.966-1.974a.514.514 0 01.28-.086h2.667c1.72 0 2.833-1.114 2.833-2.834v-4c0-1.72-1.113-2.833-2.833-2.833H4.667z"
  ></path>
  <path
  className='neededFill'
    fill="#9197B3"
    d="M8 8.073a.504.504 0 01-.5-.5v-.14c0-.773.567-1.153.78-1.3.247-.166.327-.28.327-.453A.609.609 0 008 5.073a.609.609 0 00-.607.607c0 .273-.226.5-.5.5a.504.504 0 01-.5-.5 1.608 1.608 0 013.214 0c0 .76-.56 1.14-.767 1.28-.26.173-.34.287-.34.473v.14a.5.5 0 01-.5.5zM8 9.733a.5.5 0 11-.001-.998.5.5 0 01.001.998z"
  ></path>
</svg>
)

}